import React from 'react';
import { Link } from 'react-router-dom';

const Landing = () => {
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--bg-main)', color: 'white' }}>
      <h1 className="text-gradient" style={{ fontSize: '48px', marginBottom: '20px' }}>Welcome to Our Platform</h1>
      <p style={{ color: 'var(--text-secondary)', marginBottom: '40px', fontSize: '18px' }}>
        This is a blank landing page placeholder.
      </p>
      <div style={{ display: 'flex', gap: '20px' }}>
        <Link to="/login" style={{ textDecoration: 'none' }}>
          <button className="upgrade-btn" style={{ padding: '12px 32px', fontSize: '16px' }}>Go to Login</button>
        </Link>
      </div>
    </div>
  );
};

export default Landing;
